import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=4876b5be&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=4876b5be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4876b5be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4876b5be')) {
      api.createRecord('4876b5be', component.options)
    } else {
      api.reload('4876b5be', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=4876b5be&scoped=true&", function () {
      api.rerender('4876b5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NCam07jyV3U3/JS/comp/DateRange.vue"
export default component.exports